<template>
    <div>
        <div class="container user">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <h2>
                                Add New User
                            </h2>
                        </div>
                        <div class="col-md-6 col-sm-6 text-right">
                            <a href="/users">Back To list</a>
                        </div>
                    </div>
                    <form @submit.stop.prevent="onSubmit">
                        <messages :messages="messages"/>
                        <div class="row">
                            <div class="col-md-12 container-adduser">
                                <div class="form-row">
                                    <b-form-group
                                        v-if="$userIsAdmin()"
                                        class="input-group col-md-6"
                                                  label="Company"
                                                  :label-for="getId('company_id')"
                                                  :state="fieldState('company_id')"
                                                  :invalid-feedback="invalidField('company_id')"
                                    >
                                        <b-form-select
                                            :id="getId('company_id')"
                                            v-model="user.company_id"
                                            class="form-control"
                                        >
                                            <option :value="null">Select a company</option>
                                            <option :value="company.id" v-for="company in companies">{{ company.name }}</option>
                                        </b-form-select>

                                    </b-form-group>
                                    <b-form-group class="input-group col-md-6"
                                                  label="User Name / Login"
                                                  :label-for="getId('username')"
                                                  :state="fieldState('username')"
                                                  :invalid-feedback="invalidField('username')"
                                    >
                                        <b-form-input
                                                :id="getId('username')"
                                                type="text"
                                                v-model="user.username"
                                                :state="fieldState('username')"
                                                placeholder="Enter username">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="form-row">
                                    <b-form-group class="input-group col-md-6"
                                                  label="First Name"
                                                  :label-for="getId('first_name')"
                                                  :state="fieldState('first_name')"
                                                  :invalid-feedback="invalidField('first_name')"
                                    >
                                        <b-form-input
                                                :id="getId('first_name')"
                                                type="text"
                                                v-model="user.first_name"
                                                :state="fieldState('first_name')"
                                                placeholder="Enter first name">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group class="input-group col-md-6"
                                                  label="Last Name"
                                                  :label-for="getId('last_name')"
                                                  :state="fieldState('last_name')"
                                                  :invalid-feedback="invalidField('last_name')"
                                    >
                                        <b-form-input
                                                :id="getId('last_name')"
                                                type="text"
                                                v-model="user.last_name"
                                                :state="fieldState('last_name')"
                                                placeholder="Enter last name">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="form-row">
                                    <b-form-group class="input-group col-md-6"
                                                  label="Email"
                                                  :label-for="getId('email')"
                                                  :state="fieldState('email')"
                                                  :invalid-feedback="invalidField('email')"
                                    >
                                        <b-form-input
                                                :id="getId('email')"
                                                type="text"
                                                v-model="user.email"
                                                :state="fieldState('email')"
                                                placeholder="Enter email">
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="$userIsSuperAdmin()"
                                            class="input-group col-md-6"
                                                  label="User Role"
                                                  :label-for="getId('role_id')"
                                                  :state="fieldState('role_id')"
                                                  :invalid-feedback="invalidField('role_id')"
                                    >
                                        <b-form-select
                                                :id="getId('role_id')"
                                                v-model="user.role_id"
                                                class="form-control"
                                        >
                                            <option :value="null">Choose a role</option>
                                            <option :value="role.id" v-for="role in user_roles">{{ role.name }}</option>
                                        </b-form-select>

                                    </b-form-group>
                                </div>
                                <div class="form-row" v-if="user.role_id === 2">
                                    <div class="col-md-6"></div>
                                    <b-form-group class="input-group col-md-6"
                                                  label="Sales rep"
                                                  :label-for="getId('sales_rep_id')"
                                                  :state="fieldState('sales_rep_id')"
                                                  :invalid-feedback="invalidField('sales_rep_id')"
                                    >
                                        <b-form-select
                                            :id="getId('sales_rep_id')"
                                            v-model="user.sales_rep_id"
                                            class="form-control"
                                        >
                                            <option :value="user.id" v-for="user in reps">{{ user.name }}</option>
                                        </b-form-select>

                                    </b-form-group>
                                </div>
                                <div class="form-row">
                                    <b-form-group class="input-group col-md-6"
                                                  label="Password"
                                                  :label-for="getId('password')"
                                                  :state="fieldState('password')"
                                                  :invalid-feedback="invalidField('password')"
                                    >
                                        <b-form-input
                                                :id="getId('password')"
                                                type="password"
                                                v-model="user.password"
                                                :state="fieldState('password')"
                                                placeholder="Enter password">
                                        </b-form-input>

                                    </b-form-group>
                                    <b-form-group class="input-group col-md-6"
                                                  label="Confirm password"
                                                  :label-for="getId('confirm_password')"
                                                  :state="fieldState('confirm_password')"
                                                  :invalid-feedback="invalidField('confirm_password')"
                                    >
                                        <b-form-input
                                                :id="getId('confirm_password')"
                                                type="password"
                                                v-model="user.confirm_password"
                                                :state="fieldState('confirm_password')"
                                                placeholder="Enter confirm password">
                                        </b-form-input>

                                    </b-form-group>
                                </div>
                                <div class="form-row">
                                    <b-btn type="submit" class="btn">Save</b-btn>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapActions } from 'vuex'
    import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors} from '../../util/common'
    import BootstrapValidation from '../../mixins/bootstrap-validation';
    import axios from "axios";
    export default {
        props: [
            'user_detail',
        ],
        created(){
            this.getCompanies()
            this.$store.dispatch('userStatuses/getUserStatuses');
            this.$store.dispatch('userRoles/getUserRoles');
            this.getReps()
        },
        mixins: [BootstrapValidation],
        data() {
            return {
                companies: [],
                reps: [],
                user:{
                    company_id: null,
                    first_name: null,
                    last_name: null,
                    email: null,
                    username: null,
                    password: null,
                    confirm_password: null,
                    role_id: this.$userRoleId('dealer'),
                },
                messages: [],
            }
        },
        computed: {
            ...mapState({
                countries: state => state.countries.all,
                users: state => state.users.all,
                regions: state => state.region.all,
                statuses: state => state.userStatuses.all,
                attended_auctions: state => state.attendedAuctions.all,
                user_roles: state => state.userRoles.all,
            }),

        },
        mounted() {
            this.getUser();
        },
        methods: {
            async getCompanies(){
                const res = await axios.get(this.$laravelRoute('companies.list'))
                if (res && res.data && res.data.companies) {
                    this.companies = res.data.companies
                }
            },
            async getReps(){
                let reps = await this.$store.dispatch('users/getSalesReps');
                reps.sort((a,b) => {
                    const nameA = a.name.toUpperCase();
                    const nameB = b.name.toUpperCase();

                    let comparison = 0;
                    if (nameA > nameB) {
                        comparison = 1;
                    } else if (nameA < nameB) {
                        comparison = -1;
                    }
                    return comparison;
                })
                this.reps = reps
            },
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            getId(name){
                return name;
            },
            async onSubmit(){
                this.messages = [];
                this.errors = [];
                try {
                    let response = await this.$store.dispatch('users/storeUser', {
                        data: this.user,
                    });
                    if(response){
                        this.messages.push({type: 'success', message: response.message});
                        this.errors = [];
                        if (response.user && response.user.id) {
                            let url = this.$laravelRoute('users.edit', response.user.id)
                            window.location = url
                        }
                    } else {

                    }
                } catch (error) {
                    console.warn('onSubmit error: ', error);
                    let message = getExceptionErrorMessage(error);
                    this.messages.push({type: 'danger', message});
                    let errors = getHttpValidationErrors(error);
                    if (errors) {
                        this.errors = errors;
                    }
                }
            },
            getUser(){
                if (this.userDetail) {
                    this.user = this.userDetail;
                    if (!this.user.broker_fee) {
                        this.user.broker_fee = {
                            fee: null,
                        }
                    }
                }

            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/User/AddUserPage.vue